import { DatalayerService } from '@analytics/datalayer';
import { Injectable } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { aomSubmittedAction, showAomModalAction } from './aom-modal.actions';
import { AomModalComponent } from '../aom-modal/aom-modal.component';

@Injectable()
export class AOMModalEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store,
    private readonly modalService: NgbModal,
    private readonly datalayer: DatalayerService
  ) {}

  /**
   *  Open the AOM modal and pass the required data to it
   */
  public readonly openAomModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(showAomModalAction),
        tap((action) => {
          const modal = this.modalService.open(AomModalComponent, {
            windowClass: 'modal--left',
            scrollable: true,
            keyboard: true,
          });

          // location of aomContent is different in different scopes
          // use from funnelSettings if AomContent is not available directly
          const aomContent = action.rendering?.fields?.[
            'AomContent'
          ] as unknown as InnogyComponentRendering;

          const funnelSettingsAomContent = (
            action.rendering?.fields?.[
              'FunnelSettings'
            ] as unknown as InnogyComponentRendering
          )?.fields?.['AomContent'];

          modal.componentInstance.aomContent =
            aomContent ?? funnelSettingsAomContent;

          modal.componentInstance.showFooter = action.showFooter;
          modal.componentInstance.offer = action.offer;
          modal.componentInstance.costPerUnitVM = action.costPerUnitVM;
          modal.componentInstance.consumptionValuesVM =
            action.consumptionValuesVM;
          modal.componentInstance.rendering = action.rendering;
          modal.componentInstance.orderPage = action.orderPage;
          modal.result
            // Called when modal is submitted or closed
            .then((result) => {
              if (result.submit) {
                const { offer } = action;

                this.store$.dispatch(
                  aomSubmittedAction({
                    offer,
                    orderPage: action.orderPage,
                    rendering: action.rendering,
                  })
                );
              }
            })
            // Called when modal is dismissed or closed
            .catch(() => {
              this.datalayer.pushEvent({
                event: 'link-click',
                info: {
                  name: 'Sluit AOM',
                  type: 'button',
                },
              });
            });
        })
      ),
    { dispatch: false }
  );
}
